import { render, staticRenderFns } from "./search_results.vue?vue&type=template&id=4bda9fe9&scoped=true"
import script from "./search_results.vue?vue&type=script&lang=js"
export * from "./search_results.vue?vue&type=script&lang=js"
import style0 from "./search_results.vue?vue&type=style&index=0&id=4bda9fe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bda9fe9",
  null
  
)

export default component.exports